export default __webpack_public_path__ + "static/media/SimpleSuccess.b47dc9b5.png";